{
  "adminRequirementsContent": {
    "representativesMissingDocuments": "Representatives missing documents",
    "distinctActiveRepresentativesWithOutstandingRequirementsOpenA": "Distinct active representatives with outstanding requirements. Open a person to review current versions and retained evidence.",
    "administratorAccessIsRequiredToReviewOrganizationDocument": "Administrator access is required to review organization document requirements.",
    "searchContacts": "Search Contacts",
    "nameEmailOrPhone": "Name, Email or Phone",
    "portalAccount": "Portal Account",
    "allReps": "All Reps",
    "hasPortal": "Has Portal",
    "noPortal": "No Portal",
    "search": "Search",
    "documentRequirementsUnavailable": "Document requirements unavailable",
    "retryRequirements": "Retry Requirements",
    "theOrganizationListCouldNotBeLoadedNo": "The organization list could not be loaded. No completion count is shown.",
    "loadingDocumentRequirements": "Loading document requirements…",
    "representative": "representative",
    "representatives": "representatives",
    "missingDocuments": " missing documents",
    "withAPortalAccount": " with a portal account",
    "withoutAPortalAccount": " without a portal account",
    "matchingYourSearch": " matching your search",
    "noEmailOnRecord": "No email on record",
    "noPhoneOnRecord": "No phone on record",
    "noCurrentBusinessRole": "No current business role",
    "missing": " missing",
    "hideDocuments": "Hide Documents",
    "reviewDocuments": "Review Documents",
    "documentVersion": "Document version: ",
    "signed": "Signed",
    "priorCompletionOnRecord": "Prior completion on record",
    "inProgress": "In progress",
    "signatureNeeded": "Signature needed",
    "signed2": "Signed ",
    "documentedOrganizationOnboarding": "Documented organization onboarding",
    "priorPaperworkAttestation": "Prior paperwork attestation",
    "recorded": " · recorded ",
    "auditEvidence": "Audit evidence: ",
    "priorCompletionSatisfiesThisRequirementNoNativeSigned": "Prior completion satisfies this requirement; no native signed PDF is recorded.",
    "viewSignedCopy": "View signed copy",
    "retainedSignaturesDoNotReplaceANewerRequired": "Retained signatures do not replace a newer required version.",
    "signed3": " · signed ",
    "viewRetainedSignedCopy": "View retained signed copy",
    "noRepresentativesWithOutstandingDocumentsMatchTheseFilters": "No representatives with outstanding documents match these filters.",
    "noRepresentativesHaveOutstandingDocumentRequirements": "No representatives have outstanding document requirements.",
    "documentListPages": "Document list pages",
    "previous": "Previous",
    "of": "{{value1}}–{{value2}} of {{total}}",
    "message0Results": "0 results",
    "next": "Next"
  },
  "accountLabels": {
    "portalAccountReady": "Portal account ready",
    "accountPending": "Account pending",
    "accountUnavailable": "Account unavailable",
    "noPortalAccount": "No portal account"
  },
  "documentUpdateNotice": {
    "unsigned": "{{count}} unsigned {{value2}}",
    "followUp": "{{practiceCount}} {{value2}} follow-up",
    "documentsCouldNotBeChecked": "{{value1}}Documents could not be checked",
    "retryDocumentCheck": "Retry Document Check",
    "retry": "Retry",
    "reviewAndSign": "Review and Sign",
    "reviewPracticeFollowUp": "Review Practice Follow-Up",
    "reviewSign": "Review and Sign",
    "reviewFollowUp": "Review Follow-Up"
  },
  "DocumentUpdateNotice": {
    "practiceDocumentNeeds": "practice document needs",
    "practiceDocumentsNeed": "practice documents need"
  },
  "documentUpdatesContent": {
    "yourDocuments": "Your Documents",
    "documentWork": "Document work",
    "personalSignatures": "Personal Signatures",
    "needsYourSignature": "Needs Your Signature",
    "completedAndRetainedDocuments": "Completed and Retained Documents",
    "reviewYourRequiredDocumentsAndRetainedCompletionEvidence": "Sign your own paperwork, review retained copies or follow up on Practice signatures.",
    "thisPreviewIsReadOnlyOnlyTheAccount": "This preview is read-only. Only the account owner can sign their documents.",
    "signingUnavailable": "Signing unavailable",
    "thatDocumentIsNotAssignedToYourAccount": "That document is not assigned to your account. Your available documents are listed below.",
    "yourDocumentsCouldNotBeLoaded": "Your documents could not be loaded",
    "retry": "Retry",
    "noOrganizationProfileIsLinkedToThisAccount": "No organization profile is linked to this account. Contact an administrator to review your document requirements.",
    "checkingYourDocuments": "Checking your documents…",
    "youReUpToDate": "You're up to date",
    "thereAreNoUpdatedDocumentsWaitingForYour": "There are no updated documents waiting for your signature.",
    "youCanKeepUsingThePortalWhileYou": "You can keep using the portal while you review these documents.",
    "signed": "Signed",
    "priorCompletionOnRecord": "Prior completion on record",
    "inProgress": "In progress",
    "signatureNeeded": "Signature needed",
    "documentVersion": "Document version: ",
    "thisIsAnAdditionalAgreementForAggregatorsAnd": "This is an additional agreement for Aggregators and Lab Aggregators. It is signed separately from your Representative MOU.",
    "signed2": "Signed {{value1}}",
    "documentedPriorOnboardingSatisfiesThisRequirementThisIs": "Documented prior onboarding satisfies this requirement. This is a completion record, with no native signed PDF.",
    "reviewTheFullDocumentBeforeAddingYourSignature": "Review the full document before adding your signature.",
    "completionRecorded": "Completion recorded ",
    "evidence": " · Evidence ",
    "previouslySignedCopiesRemainAvailableTheyDoNot": "Previously signed copies remain available. They do not replace the current agreement.",
    "viewPreviousCopySigned": "View previous copy signed ",
    "viewSignedCopy": "View Signed Copy",
    "previewDocument": "Preview Document",
    "continueSigning": "Continue Signing",
    "reviewAndSign": "Review and Sign",
    "previousSignedCopy": "{{title}} — previous signed copy"
  },
  "sign": {
    "theSigningSessionCouldNotBeOpenedRefresh": "The signing session could not be opened. Refresh your documents and try again."
  },
  "practiceFollowUp": {
    "practiceFollowUp": "Practice Follow-Up",
    "practiceFollowUpHeading": "Practice Follow-Up",
    "helpYourPracticesCompleteTheUpdatedCommitmentLetter": "Help your practices complete the updated commitment letter. The original Practice signer receives the private signing request and signs for the Practice.",
    "thisPreviewIsReadOnlyReturnToYour": "This preview is read-only. Return to your account to send signing requests.",
    "practiceFollowUpCouldNotBeLoaded": "Practice follow-up could not be loaded",
    "retryPracticeFollowUp": "Retry Practice Follow-Up",
    "practiceFollowUpIsUnavailableForThisAccount": "Practice follow-up is unavailable for this account.",
    "checkingPracticeFollowUp": "Checking practice follow-up…",
    "practiceDocumentNeeds": "practice document needs",
    "practiceDocumentsNeed": "practice documents need",
    "followUp": " follow-up",
    "noPreviousPracticeSignersInYourScopeNeed": "No previous Practice signers in your scope need this update.",
    "commitmentUpdate": "{{practiceName}} commitment update",
    "signed": "Signed",
    "signingInProgress": "Signing in progress",
    "practiceSignatureNeeded": "Practice signature needed",
    "signer": "Signer: ",
    "originalAgreementSigned": "Original agreement signed ",
    "updateVersion": "Update version: ",
    "updateSigned": "Update signed ",
    "lastRequest": " Last request {{value1}}.",
    "resendSigningRequest": "Resend Signing Request",
    "sendSigningRequest": "Send Signing Request",
    "practiceFollowUpPages": "Practice follow-up pages",
    "previousPractices": "Previous Practices",
    "of": " of ",
    "nextPractices": "Next Practices"
  },
  "deliveryLabel": {
    "noEmailDeliveryRecorded": "No email delivery recorded.",
    "emailProviderAcceptedTheRequestDeliveryIsNot": "Email provider accepted the request; delivery is not confirmed.",
    "emailDeliveredASignatureIsStillRequiredUntil": "Email delivered. A signature is still required until signing is complete.",
    "emailQueuedDeliveryIsNotConfirmed": "Email queued; delivery is not confirmed.",
    "emailProcessingDeliveryIsNotConfirmed": "Email processing; delivery is not confirmed.",
    "emailBouncedContactAnAdministratorToReviewThe": "Email bounced. Contact an administrator to review the recipient.",
    "emailSuppressedAfterAComplaintContactAnAdministrator": "Email suppressed after a complaint. Contact an administrator.",
    "emailFailedContactAnAdministratorToReviewDelivery": "Email failed. Contact an administrator to review delivery."
  },
  "send": {
    "theSigningRequestCouldNotBeConfirmedRetry": "The signing request could not be confirmed. Retry reuses the same request so it is not sent twice."
  },
  "pdfPreview": {
    "retainedSignedCopySuffix": " — retained signed copy",
    "signedCopySuffix": " — signed copy"
  },
  "documentCountWords": {
    "document": "document",
    "documents": "documents"
  }
}
